import React from 'react';
import './Error404.css';

export const Error404 = () => {
	
	return(
		<main className='errorContainer'>
			<h1>404</h1>
			<h3>Sorry, the page you tried cannot be found</h3>
		</main>
		)
}